import evacuation_shelter from '../../../assets/img/marker/m_evacuation-shelter.png'
import reservoir from '../../../assets/img/marker/m_reservoir.png';
import lv2 from '../../../assets/img/marker/m_lv2.png';
import lv0 from '../../../assets/img/marker/m_lv0.png';

import m_pin_blue from '../../../assets/img/marker/m_pin_blue.png';
import m_pin_sky from '../../../assets/img/marker/m_pin_sky.png';
import m_pin_orange from '../../../assets/img/marker/m_pin_orange.png';
import m_bridge from '../../../assets/img/marker/m_bridge.png';
import m_footbridge from '../../../assets/img/marker/m_footbridge.png';
import m_tunnel from '../../../assets/img/marker/m_tunnel.png';
import m_road from '../../../assets/img/marker/m_road.png';
import m_road_shed from '../../../assets/img/marker/m_road-shed.png';
import m_dam from '../../../assets/img/marker/m_dam.png';

import m_road_i_heisa from '../../../assets/img/marker/m_road-i-heisa.png';
import m_road_i_shasen from '../../../assets/img/marker/m_road-i-shasen.png';
import m_road_i_katagawa from '../../../assets/img/marker/m_road-i-katagawa.png';
import m_road_i_taimen from '../../../assets/img/marker/m_road-i-taimen.png';
import m_road_i_hokou from '../../../assets/img/marker/m_road-i-hokou.png';
import m_road_i_oogata from '../../../assets/img/marker/m_road-i-oogata.png';
import m_road_i_taiya from '../../../assets/img/marker/m_road-i-taiya.png';
import m_road_i_other from '../../../assets/img/marker/m_road-i-other.png';

import m_road_i_heisa_s from '../../../assets/img/marker/m_road-i-heisa_s.png';
import m_road_i_shasen_s from '../../../assets/img/marker/m_road-i-shasen_s.png';
import m_road_i_katagawa_s from '../../../assets/img/marker/m_road-i-katagawa_s.png';
import m_road_i_taimen_s from '../../../assets/img/marker/m_road-i-taimen_s.png';
import m_road_i_hokou_s from '../../../assets/img/marker/m_road-i-hokou_s.png';
import m_road_i_oogata_s from '../../../assets/img/marker/m_road-i-oogata_s.png';
import m_road_i_taiya_s from '../../../assets/img/marker/m_road-i-taiya_s.png';
import m_road_i_other_s from '../../../assets/img/marker/m_road-i-other_s.png';

import m_road_i_heisa_t from '../../../assets/img/marker/m_road-i-heisa_t.png';
import m_road_i_shasen_t from '../../../assets/img/marker/m_road-i-shasen_t.png';
import m_road_i_katagawa_t from '../../../assets/img/marker/m_road-i-katagawa_t.png';
import m_road_i_taimen_t from '../../../assets/img/marker/m_road-i-taimen_t.png';
import m_road_i_hokou_t from '../../../assets/img/marker/m_road-i-hokou_t.png';
import m_road_i_oogata_t from '../../../assets/img/marker/m_road-i-oogata_t.png';
import m_road_i_taiya_t from '../../../assets/img/marker/m_road-i-taiya_t.png';
import m_road_i_other_t from '../../../assets/img/marker/m_road-i-other_t.png';

import m_road_i_heisa_m from '../../../assets/img/marker/m_road-i-heisa_m.png';
import m_road_i_shasen_m from '../../../assets/img/marker/m_road-i-shasen_m.png';
import m_road_i_katagawa_m from '../../../assets/img/marker/m_road-i-katagawa_m.png';
import m_road_i_taimen_m from '../../../assets/img/marker/m_road-i-taimen_m.png';
import m_road_i_hokou_m from '../../../assets/img/marker/m_road-i-hokou_m.png';
import m_road_i_oogata_m from '../../../assets/img/marker/m_road-i-oogata_m.png';
import m_road_i_taiya_m from '../../../assets/img/marker/m_road-i-taiya_m.png';
import m_road_i_other_m from '../../../assets/img/marker/m_road-i-other_m.png';

import m_road_r_rain from '../../../assets/img/marker/m_road-r-rain.png';
import m_road_r_wind from '../../../assets/img/marker/m_road-r-wind.png';
import m_road_r_wave from '../../../assets/img/marker/m_road-r-wave.png';
import m_road_r_kansui from '../../../assets/img/marker/m_road-r-kansui.png';
import m_road_r_bridge from '../../../assets/img/marker/m_road-r-bridge.png';
import m_road_r_winter from '../../../assets/img/marker/m_road-r-winter.png';
import m_road_r_ice from '../../../assets/img/marker/m_road-r-ice.png';

import m_road_camera from '../../../assets/img/marker/m_road-camera.png';
import m_road_condition from '../../../assets/img/marker/m_road-condition.png';
import m_road_camera_condition from '../../../assets/img/marker/m_road-camera-condition.png';

import m_road_hosou from '../../../assets/img/marker/m_road_hosou.png';
import m_road_norimen from '../../../assets/img/marker/m_road_norimen.png';

import m_teibou_gogan from '../../../assets/img/marker/m_teibou-gogan.png';
import m_haisui_kouwan from '../../../assets/img/marker/m_haisui-kouwan.png';
import m_kasen_tunnel from '../../../assets/img/marker/m_kasen-tunnel.png';
import m_chika_chousei_ike from '../../../assets/img/marker/m_chika-chousei-ike.png';
import m_chousei_ike from '../../../assets/img/marker/m_chousei-ike.png';
import m_haisui_kasen from '../../../assets/img/marker/m_haisui-kasen.png';

import m_entei_kou from '../../../assets/img/marker/m_entei-kou.png';
import m_keiryu_hozen from '../../../assets/img/marker/m_keiryu-hozen.png';
import m_kyuu_keisha from '../../../assets/img/marker/m_kyuu-keisha.png';
import m_jisuberi from '../../../assets/img/marker/m_jisuberi.png';

import m_suimon from '../../../assets/img/marker/m_suimon.png';

import m_kouwan_gaikaku from '../../../assets/img/marker/m_kouwan_gaikaku.png';
import m_gyokou_keiryuu from '../../../assets/img/marker/m_gyokou_keiryuu.png';
import m_kouwan_keiryuu from '../../../assets/img/marker/m_kouwan_keiryuu.png';
import m_kouwan_rinkou from '../../../assets/img/marker/m_kouwan_rinkou.png';
import m_kaigan_shisetsu from '../../../assets/img/marker/m_kaigan-shisetsu.png';
import m_gyokou_gaikaku from '../../../assets/img/marker/m_gyokou_gaikaku.png';
import m_gyokou_rinkou from '../../../assets/img/marker/m_gyokou_rinkou.png';

import m_denshou_info from '../../../assets/img/marker/m_sabou_info.png';
import m_denshou_stone from '../../../assets/img/marker/m_denshou-info.png';
import m_denshou_record from '../../../assets/img/marker/m_sabou_record.png';

import m_camera_dam from '../../../assets/img/marker/m_camera-dam.png';
import m_camera_kaigan from '../../../assets/img/marker/m_camera-kaigan.png';
import m_camera_kouwan from '../../../assets/img/marker/m_camera-kouwan.png';
import m_camera_park from '../../../assets/img/marker/m_camera-park.png';
import m_camera_river from '../../../assets/img/marker/m_camera-river.png';
import m_camera_road from '../../../assets/img/marker/m_camera-road.png';
import m_camera_sabou from '../../../assets/img/marker/m_camera-sabou.png';
import m_camera_tameike from '../../../assets/img/marker/m_camera-tameike.png';


import m_sea__route from '../../../assets/img/marker/m_sea-__route.png';
import m_kyuukeishachi from '../../../assets/img/marker/m_kyuukeishachi.png';
import m_steep_slope_law from '../../../assets/img/marker/m_steep-slope_law.png';
import m_bombed_tree from '../../../assets/img/marker/m_bombed-tree.png';

// 盛り土
import m_morido_01 from '../../../assets/img/marker/m_morido_01.png';
import m_morido_02 from '../../../assets/img/marker/m_morido_02.png';
import m_morido_03 from '../../../assets/img/marker/m_morido_03.png';

import m_dourodaichou from '../../../assets/img/marker/m_dourodaichou.png';
import m_infra_tourism from '../../../assets/img/marker/m_infra-tourism.png';
import m_emergency_phone from '../../../assets/img/marker/m_emergency-phone.png';
import m_apartment from '../../../assets/img/marker/m_apartment.png';

import m_96_1 from '../../../assets/img/marker/m_pin_blue.png';

// 学校
import m_98_3 from '../../../assets/img/marker/m_fs-shogakko.png';
import m_98_4 from '../../../assets/img/marker/m_fs-chugakko.png';
import m_98_5 from '../../../assets/img/marker/m_fs-chutokyoiku-gakko.png';
import m_98_6 from '../../../assets/img/marker/m_fs-kotogakko.png';
import m_98_7 from '../../../assets/img/marker/m_fs-senmongakko.png';
import m_98_8 from '../../../assets/img/marker/m_fs-tankidaigaku.png';
import m_98_9 from '../../../assets/img/marker/m_fs-daigaku.png';
import m_98_10 from '../../../assets/img/marker/m_fs-tokubetsushien-gakko.png';
import m_98_11 from '../../../assets/img/marker/m_fs-gimukyoiku-gakko.png';
import m_98_12 from '../../../assets/img/marker/m_fs-kakushu-gakko.png';
import m_98_13 from '../../../assets/img/marker/m_fs-senshu-gakko.png';

// 幼稚園
import m_98_14 from '../../../assets/img/marker/m_fh-yochien.png';
import m_98_15 from '../../../assets/img/marker/m_fh-kodomoen.png';
import m_98_16 from '../../../assets/img/marker/m_fh-hoikusho.png';
import m_98_17 from '../../../assets/img/marker/m_fh-tiikigata-hoiku.png';
import m_98_18 from '../../../assets/img/marker/m_fh-ninkagai-hoiku.png';

// 医療機関
import m_98_19 from '../../../assets/img/marker/m_fh-byoin.png';
import m_98_20 from '../../../assets/img/marker/m_fh-shinryosho.png';  
import m_98_21 from '../../../assets/img/marker/m_fh-shika.png';

// 福祉施設
import m_98_22 from '../../../assets/img/marker/m_ff-hogoshisetsu.png';
import m_98_23 from '../../../assets/img/marker/m_ff-rojinfukushi.png';
import m_98_24 from '../../../assets/img/marker/m_ff-shogaishashien.png';
import m_98_25 from '../../../assets/img/marker/m_ff-shintaishogaisha.png';  
import m_98_26 from '../../../assets/img/marker/m_ff-jidofukushi.png';
import m_98_27 from '../../../assets/img/marker/m_ff-boshi-fushi.png';
import m_98_28 from '../../../assets/img/marker/m_ff-sonota-shakaifukushi.png';

// 図書館
import m_98_29 from '../../../assets/img/marker/m_f-toshokan.png';

// 役場
import m_98_30 from '../../../assets/img/marker/m_f-yakuba.png';  
import m_98_31 from '../../../assets/img/marker/m_f-kominkan.png';

// 駅
import m_98_32 from '../../../assets/img/marker/m_ft-shinkansen.png';
import m_98_33 from '../../../assets/img/marker/m_ft-zairaisen.png';
import m_98_34 from '../../../assets/img/marker/m_ft-sonota.png';

// マンホール
import m_manhole from '../../../assets/img/marker/m_manhole.png';

// 文化財
import m_kofun from '../../../assets/img/marker/m_bunka_kofun.png';
import m_kofun_90_11_3 from "../../../assets/img/marker/m_bunka_kaizuka.png";
import m_kofun_90_11_4 from "../../../assets/img/marker/m_bunka_shuraku.png";
import m_kofun_90_11_5 from "../../../assets/img/marker/m_bunka_tojo_kanga.png";
import m_kofun_90_11_6 from "../../../assets/img/marker/m_bunka_jokan.png";
import m_kofun_90_11_7 from "../../../assets/img/marker/m_bunka_shaji.png";
import m_kofun_90_11_8 from "../../../assets/img/marker/m_bunka_seisan.png";
import m_kofun_90_11_9 from "../../../assets/img/marker/m_bunka_funbo.png";
import m_kofun_90_11_10 from "../../../assets/img/marker/m_bunka_kindai.png";
import m_kofun_90_11_11 from "../../../assets/img/marker/m_bunka_sonota.png";
import m_kofun_90_11_12 from "../../../assets/img/marker/m_bunka_suichu.png";



const menu2icon = {

    "default": m_pin_blue,
  
    //インフラ情報（道路）
    "橋梁": m_bridge,
    "横断歩道橋": m_footbridge,
    "トンネル": m_tunnel,
    "門型標識": m_road,
    "シェッド": m_road_shed,
    "道路_舗装":m_road_hosou,
    "道路_のり面":m_road_norimen,
    //インフラ情報（ダム）
    "ダム": m_dam,
    //避難所情報 
    "避難所情報": evacuation_shelter,
    //土砂災害リスク情報
    "急傾斜地崩壊危険区域_がけ崩れ": m_pin_orange,
    //ため池ポイント
    "ため池ポイント": m_pin_sky,
    //ボーリングデータ
    "ボーリングデータ": m_pin_blue,
    //道路規制情報
    //本日&今後の規制
    
    /* 通常の8アイコン */
    "blocked": m_road_i_heisa, //通行止め
    "narrows": m_road_i_shasen,//車線規制
    "one_side": m_road_i_katagawa,//片側交互通行
    "two_way": m_road_i_taimen,//対面通行
    "walker_bike": m_road_i_hokou, //歩行者・二輪車通行止め
    "big_blocked": m_road_i_oogata,//大型車通行止め
    "chain": m_road_i_taiya,//チェーン規制
    "controll_complex": m_road_i_other,//その他
    
    /* 災害規制、事故規制の8アイコン */
    "blocked_disaster": m_road_i_heisa_s, //通行止め
    "narrows_disaster": m_road_i_shasen_s,//車線規制
    "one_side_disaster": m_road_i_katagawa_s,//片側交互通行
    "two_way_disaster": m_road_i_taimen_s,//対面通行
    "walker_bike_disaster": m_road_i_hokou_s, //歩行者・二輪車通行止め
    "big_blocked_disaster": m_road_i_oogata_s,//大型車通行止め
    "chain_disaster": m_road_i_taiya_s,//チェーン規制
    "controll_complex_disaster": m_road_i_other_s,//その他

    /* 冬期閉鎖の8アイコン */
    "blocked_winter": m_road_i_heisa_t, //通行止め
    "narrows_winter": m_road_i_shasen_t,//車線規制
    "one_side_winter": m_road_i_katagawa_t,//片側交互通行
    "two_way_winter": m_road_i_taimen_t,//対面通行
    "walker_bike_winter": m_road_i_hokou_t, //歩行者・二輪車通行止め
    "big_blocked_winter": m_road_i_oogata_t,//大型車通行止め
    "chain_winter": m_road_i_taiya_t,//チェーン規制
    "controll_complex_winter": m_road_i_other_t,//その他
    
    /* 事前通行規制の8アイコン */
    "blocked_before": m_road_i_heisa_m, //通行止め
    "narrows_before": m_road_i_shasen_m,//車線規制
    "one_side_before": m_road_i_katagawa_m,//片側交互通行
    "two_way_before": m_road_i_taimen_m,//対面通行
    "walker_bike_before": m_road_i_hokou_m, //歩行者・二輪車通行止め
    "big_blocked_before": m_road_i_oogata_m,//大型車通行止め
    "chain_before": m_road_i_taiya_m,//チェーン規制
    "controll_complex_before": m_road_i_other_m,//その他
    
    //事前通行規制区間
    "nami":m_road_r_wave,
    "rain":m_road_r_rain,
    "kansui":m_road_r_kansui,
    "wind":m_road_r_wind,
    "rinko":m_road_r_bridge,
    "original_kaita_bridge":m_road_r_bridge,
    // "chain":m_road_i_taiya, //共通
    "snow":m_road_r_winter,
    "frozen":m_road_r_ice,
    //気象観測情報 
    "カメラ":m_road_camera,
    "データ":m_road_condition,
    "カメラとデータ":m_road_camera_condition,
    //インフラ情報（河川） 
    // "vis_17":m_teibou_gogan,
    "vis_18": m_haisui_kouwan,
    "vis_19":m_kasen_tunnel,
    "vis_20":m_chika_chousei_ike,
    "vis_21":m_chousei_ike,
    "vis_22":m_haisui_kasen,
    "vis_32":m_pin_blue,
    "vis_34":m_pin_blue,
    "vis_36":m_pin_blue,
    "vis_38":m_pin_blue,
    "vis_39":m_pin_blue,
    "vis_66": m_denshou_stone,
    "vis_66_record": m_denshou_record,
    "vis_66_info": m_denshou_info,

    "vis_78_3": m_kyuukeishachi,
    
    "vis_87_road": m_camera_road,
    "vis_87_river": m_camera_river,
    "vis_87_dam": m_camera_dam,
    "vis_87_kaigan": m_camera_kaigan,
    "vis_87_kouwan": m_camera_kouwan,
    "vis_87_park": m_camera_park,
    "vis_87_sabou": m_camera_sabou,
    "vis_87_tameike": m_camera_tameike,
    
    "vis_89": m_sea__route,
    
    "vis_90_3": m_steep_slope_law,
    "vis_90_15": m_bombed_tree,

		// 盛り土
    "vis_90_16_3": m_morido_01,
    "vis_90_16_4": m_morido_02,
    "vis_90_16_5": m_morido_03,
    
    // 道路台帳附図
    "vis_92":m_dourodaichou,
    // インフラツーリズムマップ - 施設情報
    "vis_94":m_infra_tourism,
    "vis_95": m_emergency_phone,
    // マンション評価情報
    "vis_95_7": m_apartment,

    "vis_90_11_2": m_kofun,
    "vis_90_11_3": m_kofun_90_11_3,
    "vis_90_11_4": m_kofun_90_11_4,
    "vis_90_11_5": m_kofun_90_11_5,
    "vis_90_11_6": m_kofun_90_11_6,
    "vis_90_11_7": m_kofun_90_11_7,
    "vis_90_11_8": m_kofun_90_11_8,
    "vis_90_11_9": m_kofun_90_11_9,
    "vis_90_11_10": m_kofun_90_11_10,
    "vis_90_11_11": m_kofun_90_11_11,
    "vis_90_11_12": m_kofun_90_11_12,

    // 建築確認番号（三次市）
    "vis_96_1": m_96_1,

    // 
    "vis_97_4": m_pin_blue,

    "vis_98_3": m_98_3,
    "vis_98_4": m_98_4,
    "vis_98_5": m_98_5,
    "vis_98_6": m_98_6,
    "vis_98_7": m_98_7,
    "vis_98_8": m_98_8,
    "vis_98_9": m_98_9,
    "vis_98_10": m_98_10,
    "vis_98_11": m_98_11,
    "vis_98_12": m_98_12,
    "vis_98_13": m_98_13,
    "vis_98_14": m_98_14,
    "vis_98_15": m_98_15,
    "vis_98_16": m_98_16,
    "vis_98_17": m_98_17,
    "vis_98_18": m_98_18,
    "vis_98_19": m_98_19,
    "vis_98_20": m_98_20,
    "vis_98_21": m_98_21,
    "vis_98_22": m_98_22,
    "vis_98_23": m_98_23,
    "vis_98_24": m_98_24,
    "vis_98_25": m_98_25,
    "vis_98_26": m_98_26,
    "vis_98_27": m_98_27,
    "vis_98_28": m_98_28,
    "vis_98_29": m_98_29,
    "vis_98_30": m_98_30,
    "vis_98_31": m_98_31,
    "vis_98_32": m_98_32,
    "vis_98_33": m_98_33,
    "vis_98_34": m_98_34,

    "vis_99_1":m_haisui_kasen,
    "vis_99_2":m_manhole,
    "vis_99_4":m_haisui_kasen,

    //インフラ情報（砂防） 
    "砂防堰堤":m_entei_kou,
    "渓流保全工":m_keiryu_hozen,
    "急傾斜地崩壊防止施設":m_kyuu_keisha,
    "地すべり防止施設":m_jisuberi,
    //インフラ情報（港湾・漁港）
    "外郭施設（港湾）":m_kouwan_gaikaku,
    "係留施設（港湾）":m_kouwan_keiryuu,
    "臨港交通施設（港湾）":m_kouwan_rinkou,
    "外郭施設（漁港）":m_gyokou_gaikaku,
    "係留施設（漁港）":m_gyokou_keiryuu,
    "臨港交通施設（漁港）":m_gyokou_rinkou,
    //インフラ情報（海岸）
    "防潮扉（水門・陸閘）":m_suimon,
    "海岸保全施設":m_kaigan_shisetsu,
    "防潮水門・排水機場":m_haisui_kouwan,
    //過去の災害情報
    "土砂災害情報":m_denshou_info,

    "砂防関係指定地": lv2,
    "砂防設備・急傾斜崩壊対策": lv0,
};

export {
    menu2icon
}
